@if (vendorId()) {
<app-vendor-form-wrapper
  data-testid="vendor-view-form-wrapper"
  [mode]="'view'"
  [vendorId]="vendorId()!"
></app-vendor-form-wrapper>
}

